import React from 'react'
import {
   faFacebookF as faFacebook,
   faXTwitter as faXTwitter,
   faInstagram,
   faLinkedinIn as faLinkedin
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const IconsList = [
   {
      icon: faFacebook,
      link: "https://facebook.com"
   },
   {
      icon: faXTwitter,
      link: "https://x.com"
   },
   {
      icon: faInstagram,
      link: "https://instagram.com"
   },
   {
      icon: faLinkedin,
      link: "https://linkedin.com"
   }
]

function SideCard() {
   return (
      <div className='bg-white rounded-xl shadow-md p-6 border w-full border-gray-200 h-fit
      relative z-10 -mt-32 dark:bg-dark-5 dark:border-dark-1   '>
         <div className="flex justify-between items-center">
            <div className="text-2xl text-dark-1 font-bold dark:text-white">$96.00</div>
            <div className="flex items-center">
               <span className="text-gray-500 dark:text-gray-400 line-through mr-2">$76.00</span>
               <span className="text-sm font-medium bg-green-400 text-dark-1 px-2 py-1 rounded
               dark:text-white">
                  91% off
               </span>
            </div>
         </div>
         <div className="space-y-4 mt-6">
            <div className="flex justify-between py-2 border-b border-gray-200">
               <div className="flex items-center text-dark-1 dark:text-white">
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                  <span>Total Slot</span>
               </div>
               <span className='text-gray-500 dark:text-gray-400'>587</span>
            </div>
            <div className="flex justify-between py-2">
               <div className="flex items-center text-dark-1 dark:text-white">
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                  <span>Booked Slot</span>
               </div>
               <span className='text-gray-500 dark:text-gray-400'>987</span>
            </div>
         </div>
         <div className="mt-6 w-full font-sans">
            <button type='submit' className='text-[16px] h-[60px] w-full px-14 py-3 bg-purple-1 border border-purple-1
                       text-white hover:bg-white hover:text-purple-1 rounded-lg transition-colors'>
               Book Now
            </button>
         </div>
         <div className="px-6 py-4 border-t border-gray-200 dark:border-dark-5 bg-white dark:bg-dark-5">
            <div className="flex justify-center space-x-4">
               {IconsList.map((social) => (
                  <a
                     key={social.link} href={social.link}
                     className="flex justify-center items-center w-10 h-10 rounded-full bg-gray-100 dark:bg-dark-6
                     hover:bg-gray-200 dark:hover:bg-dark-1 transition-colors duration-300"
                     aria-label={`Share on ${social}`}
                  >
                     <FontAwesomeIcon icon={social.icon} size="sm" className="text-gray-600 dark:text-gray-300" />
                  </a>
               ))}
            </div>
         </div>
      </div>
   )
}

export default SideCard